export default __webpack_public_path__ + "static/media/servicio-delivery-houser.c2a9bcc6.jpg";